import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	updateContactDetails,
	updatePassword
} from '../../../../../actions/account/account';
import ContactDetailsForm from './ContactDetailsForm';
import PasswordReset from './PasswordReset';
import { Loader } from "../../../../common/elements";

class SettingsSections extends Component {
	handleUpdateContactDetails(personId, contactDetails) {
		this.props.updateContactDetails(personId, contactDetails);
	};

	handleUpdatePassword(password) {
		this.props.updatePassword(password);

		if (parseInt(localStorage.getItem('reset_password'), 10) === 1) {
			localStorage.setItem('reset_password', 0);
			localStorage.setItem('changed_password', 1);
		}
	};

	render() {
		const { network, personId, preferredNetwork } = this.props;
		const firstTimeLoginPrompt = localStorage.reset_password === 1 ? 'Please change your password' : null;

		if (!preferredNetwork) return <Loader network={network} />;

		if (this.props) {
			return (
				<div>
					{
						parseInt(localStorage.reset_password, 10) === 0 && parseInt(localStorage.first_login, 10) === 0 &&
						<div>
							<h3 className="h3">Edit your account settings</h3>
							<ContactDetailsForm
								{...this.props}
								handleFormSubmit={(contactDetails) => {
									this.handleUpdateContactDetails(personId, contactDetails)
								}}
							/>
							<hr />
						</div>
					}

					<h3 className="h3">Change your password</h3>
					{firstTimeLoginPrompt &&
						<i>{firstTimeLoginPrompt}</i>
					}
					<PasswordReset
						{...this.props}
						handleFormSubmit={(password) => {
							this.handleUpdatePassword(password)
						}}
					/>
				</div>
			)
		}
	}
}

SettingsSections.propTypes = {
	network: PropTypes.object,
	personId: PropTypes.string,
	updateContactDetails: PropTypes.func,
	updatePassword: PropTypes.func,
	setPreferredNetwork: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
	return {
		updateContactDetails: (personId, contactDetails) => dispatch(updateContactDetails(personId, contactDetails)),
		updatePassword: (password) => dispatch(updatePassword(password)),
	}
};

export default connect(null, mapDispatchToProps)(SettingsSections);



// WEBPACK FOOTER //
// src/client/components/site/features/account/basic/SettingsSections.js